import { api, ApiCallOptions } from '~/api';
import type { SignResponse } from '~/types/platform';

const call = <T>(path: string, args: ApiCallOptions = {}) => api<T>(`/agreements` + path, args);

export function signInfo(id: number): Promise<SignResponse> {
    return call<SignResponse>(`/${id}`);
}

export function sign(id: number): Promise<SignResponse> {
    return call<SignResponse>(`/${id}`, { method: 'POST' });
}
